import { findMatchingConfig } from '@gumtree/third-party-ads/src/framework/partnership/slot-config';

import {
    DeviceType,
    L2Category,
    L3Category,
} from '@gumtree/shared/src/types/advertising/partnership';
import { L1Category } from '@gumtree/shared/src/types/client-data';

export function useShouldShowGAMPartnershipAds(
    slotId: string,
    deviceType: DeviceType | undefined,
    l1Category: L1Category | undefined,
    l2Category: L2Category,
    l3Category: L3Category | undefined,
    bffUrl: string,
    canonicalUrl: string
) {
    if (!deviceType) {
        return false;
    }

    const slotConfig = findMatchingConfig({
        slotId,
        gaPageType: 'VIP',
        l1Category,
        l2Category,
        l3Category,
        deviceType,
        baseUrl: bffUrl,
        canonicalUrl,
    });

    if (slotConfig) {
        return false;
    }

    // Do not show GAM Partnership Ads on mobile if compact1 slot is AnyVan
    if (deviceType === 'mobile' && slotId === 'partnerAdCompact2') {
        const compact1SlotConfig = findMatchingConfig({
            slotId: 'partnerAdCompact1',
            gaPageType: 'VIP',
            l1Category,
            l2Category,
            l3Category,
            deviceType,
            baseUrl: bffUrl,
            canonicalUrl,
        });

        if (compact1SlotConfig && compact1SlotConfig.templateId === 'vip-compact-anyvan') {
            return false;
        }
    }

    if (
        l1Category === 'for-sale' ||
        l1Category === 'community' ||
        l1Category === 'business-services' ||
        l1Category === 'jobs' ||
        l1Category === 'flats-houses' ||
        l1Category === 'pets'
    ) {
        return true;
    }

    return Boolean(slotConfig);
}
